import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

export interface IBOEDiscrepancyIconProps {
    section: string;
    metricNames: string[];
    className?: string;
}

const BOEDiscrepancyIcon = ({ section, metricNames, className }: IBOEDiscrepancyIconProps) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const toggleTooltip = () => {
        setOpenTooltip(!openTooltip);
    };

    return (
        <div className={className}>
            <FontAwesomeIcon
                id={`${section}-tooltip`}
                icon={faTriangleExclamation}
                className="text-warning"
            />
            <Tooltip
                target={`${section}-tooltip`}
                isOpen={openTooltip}
                toggle={toggleTooltip}
                placement="top"
            >
                <strong>Discrepancies with Back-Of-Envelope</strong>
                <div>{metricNames.join(', ')}</div>
            </Tooltip>
        </div>
    );
};

export default BOEDiscrepancyIcon;
